export default __webpack_public_path__ + "static/media/menu_news.43125111.svg";